import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Synchronise passes</Typography>
    <p>Synchronisation sends the latest template design and eligible template values to passes that were issued before a template change. It does not create new passes.</p>

    <Typography variant='h5'>What will be updated</Typography>
    <p>The page shows the number of affected passes before you submit. Review the template and pass mode carefully, then confirm the action. Passes that do not need an update are not included.</p>

    <Typography variant='h5'>Before you synchronise</Typography>
    <ul>
      <li>Issue and inspect a test pass after significant template changes.</li>
      <li>Check the affected count, especially after changing images, colours or field layout.</li>
      <li>Use notifications separately if pass holders need to be told about the change.</li>
    </ul>
  </div>
)

export default HelpText
